import { Box, Typography, Stack } from '@mui/material';
import React from 'react';
import HighlightMatch from './HighlightMatch';

interface SearchResultItemProps {
  itemProps: React.HTMLAttributes<HTMLLIElement>;
  title: string;
  icon: React.ReactElement;
  subtitle1?: string | null;
  subtitle2?: string;
  inputValue?: string;
  chip?: React.ReactElement;
}

const SearchResultItem: React.FC<SearchResultItemProps> = ({
  itemProps,
  title,
  icon,
  subtitle1,
  subtitle2,
  inputValue,
  chip,
}) => {
  return (
    <Box
      component="li"
      key={`${title}-${subtitle1}`}
      {...itemProps}
      sx={{ 
        display: 'flex', 
        alignItems: 'center',
        p: 1,
      }}
    >
      <Stack direction='row' alignItems='flex-start'>
        <Box sx={{ display: 'flex', alignItems: 'center', mr: 1 }}>
          {icon}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
          <Typography variant="body1">
            <HighlightMatch text={title} query={`${inputValue}`} />
          </Typography>
          {subtitle1 && (
            <Typography variant="body2" color="text.secondary">
              <HighlightMatch text={subtitle1} query={`${inputValue}`} />
            </Typography>
          )}
          {subtitle2 && (
            <Typography variant="body2" color="text.secondary">
              <HighlightMatch text={subtitle2} query={`${inputValue}`} />
            </Typography>
          )}
        </Box>
        {chip && (
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 1 }}>
              {chip}
          </Box>
        )}
      </Stack>
      
    </Box>
  );
};


export default SearchResultItem;
